"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AudioContent;

function AudioContent() {
  return {
    width: '100%'
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvQXVkaW9Db250ZW50LnRzIl0sIm5hbWVzIjpbIkF1ZGlvQ29udGVudCIsIndpZHRoIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQWUsU0FBU0EsWUFBVCxHQUF3QjtBQUNyQyxTQUFPO0FBQ0xDLElBQUFBLEtBQUssRUFBRTtBQURGLEdBQVA7QUFHRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gQXVkaW9Db250ZW50KCkge1xuICByZXR1cm4ge1xuICAgIHdpZHRoOiAnMTAwJSdcbiAgfTtcbn1cbiJdfQ==